// eslint-disable-next-line max-len
export default class TemplateSelectorBase {
    constructor() {
        this.name = '';
        this._matchers = [];
    }
    matches(criteria) {
        if (!this.shouldMatch(criteria)) {
            console.warn('Cannot render view for', criteria);
            return false;
        }
        return this._matchers.every(matcher => matcher.call(matcher, criteria));
    }
    push(matcher) {
        this._matchers.push(matcher);
    }
}
//# sourceMappingURL=TemplateSelector.js.map